package com.schoolconnect.app.repository.parentportalnotes

import com.schoolconnect.app.datasource.network.KtorApiClient
import com.schoolconnect.app.datasource.network.request.ParentNoteReplyCreateRequest
import kotlinx.serialization.json.JsonObject

object ParentPortalNotesRepository {
    suspend fun load(
        studentId: String,
        status: String? = null,
        limit: Int,
        offset: Int,
        search: String? = null,
        teacherId: String? = null,
        createdFrom: String? = null,
        createdTo: String? = null,
        sortBy: String,
        order: String
    ): Result<JsonObject> = KtorApiClient.getParentPortalNotes(
        studentId = studentId.trim(),
        status = status,
        limit = limit.coerceIn(1, 100),
        offset = offset.coerceAtLeast(0),
        search = search?.trim()?.takeIf(String::isNotBlank),
        teacherId = teacherId?.trim()?.takeIf(String::isNotBlank),
        createdFrom = createdFrom?.trim()?.takeIf(String::isNotBlank),
        createdTo = createdTo?.trim()?.takeIf(String::isNotBlank),
        sortBy = sortBy,
        order = order
    )

    suspend fun loadSummary(studentId: String): Result<JsonObject> =
        KtorApiClient.getParentPortalNotesSummary(studentId.trim())

    suspend fun loadDetail(parentNoteId: String, studentId: String): Result<JsonObject> =
        KtorApiClient.getParentPortalNoteDetail(parentNoteId.trim(), studentId.trim())

    suspend fun reply(parentNoteId: String, message: String, attachmentFileIds: List<String>): Result<JsonObject> =
        KtorApiClient.createParentPortalNoteReply(
            parentNoteId.trim(),
            ParentNoteReplyCreateRequest(message.trim(), attachmentFileIds.map(String::trim).filter(String::isNotBlank))
        )
}
